import { EClientData } from "dto/IClient";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import Avatar from "components/Avatar";
import NotFoundScreen from "components/NotFoundScreen";
import { useTranslation } from "react-i18next";

const PersonsClient: FC<Props> = ({ client }) => {
  const { t } = useTranslation();
  const contactPersons =
    client?.Data?.filter?.((d) => d.Type === EClientData.CONTACT_PERSON) ?? [];
  return (
    <div className={styles.wrapper}>
      {contactPersons.length === 0 && (
        <div className={styles.empty}>
          <NotFoundScreen
            size="small"
            title={t("emptyStates.noContacts")}
            text={t("emptyStates.addFirst")}
            buttonName={t("personsClient.addContactPerson")}
            onClick={() => {}}
          />
        </div>
      )}

      {contactPersons.map((m) => {
        const json: any = JSON.parse(m.Value);

        return (
          <div className={styles.box}>
            <Avatar
              name={`${json.FirstName ?? json.firstName} ${
                json.LastName ?? json.lastName
              }`}
            />
            <div className={styles.name}>
              {json.FirstName ?? json.firstName}{" "}
              {json.LastName ?? json.lastName}
              <br />
              {(json.Phone || json.phone) && (
                <>{t("personsClient.phoneNumberLabel")}: {json.Phone ?? json.phone}</>
              )}
              <br />
              {(json.Email || json.email) && (
                <>{t("personsClient.emailLabel")}: {json.Email ?? json.email}</>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PersonsClient;
